import React, { useEffect } from "react";
// import { Route, Routes } from "react-router-dom";
import "./App.css";
import "./assets/css/enrol.css";
import "./assets/css/style.css";
import Header from "./components/Header";
import Home from "./pages/Home";
import { Route, Routes, useLocation } from "react-router";
import EnrollNow from "./pages/Programs/EnrollNow";
import Footer from "./components/Footer";
import Saleforce from "./pages/Programs/Saleforce";
import WebDevelopment from "./pages/Programs/WebDevelopment";
import Devops from "./pages/Programs/Devops";
import AppDevelopment from "./pages/Programs/AppDevelopment";
import CloudComputing from "./pages/Programs/CloudComputing";
import Basic from "./pages/Internships/Basic";
import Intermediate from "./pages/Internships/Intermediate";
import Expert from "./pages/Internships/Expert";

function App() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location]);

  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/enroll-now" element={<EnrollNow />} />
        <Route path="/salesforce" element={<Saleforce />} />
        <Route path="/devops" element={<Devops />} />
        <Route path="/web-devlopement" element={<WebDevelopment />} />
        <Route path="/app-development" element={<AppDevelopment />} />
        <Route path="/cloud-computing" element={<CloudComputing />} />
        <Route path="/basic" element={<Basic />} />
        <Route path="/intermediate" element={<Intermediate />} />
        <Route path="/expert" element={<Expert />} />
        {/* <Route path="/" element={<Home />} /> */}
      </Routes>
      <Footer />
    </>
  );
}

export default App;
